/**
 * Pads a number with a leading zero if it is less than 10.
 * @param {number} value - The value to pad.
 * @returns {string}
 */
export function padTime(value) {
    const _val = parseInt(value, 10);
    return _val >= 10 ? _val.toString() : `0${_val}`;
}
